import { createRouterSelector } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import logger from '@atlassian/jira-common-util-logging/src/log.tsx';
import { useMatch } from '../../../utils/use-match/index.tsx';
import { useQuery } from '../../../utils/use-query/index.tsx';

export function useGetCurrentUrl(): string {
	const match = useMatch();
	const query = useQuery();

	const searchParams = new URLSearchParams(query ?? {});
	const url = new URL(`http://example.com${match.url}/?${searchParams.toString()}`);
	return url.toString();
}

export const useGetCurrentUrlPath = createRouterSelector((routerContext) => {
	if (fg('chronos-extra-logging-for-url-path')) {
		try {
			const url = new URL(`http://example.com${routerContext.match.url}`);
			return url.toString();
		} catch (error) {
			logger.unsafeErrorWithCustomerData(
				'navigation-apps.sidebar-nav4.use-get-current-url',
				'Failed to construct URL',
				{
					urlPath: routerContext.match.url,
				},
			);
			throw error;
		}
	}
	const url = new URL(`http://example.com${routerContext.match.url}`);
	return url.toString();
});
